<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; gap: 20px;">
  <div></div>
  <div style="display: flex; flex-direction: row; gap: 20px;">
    <div></div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <!--Account Detail Toolbar-->
      <mat-toolbar color="primary" class="toolbar-over-card">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
          <mat-card-title>Account Information</mat-card-title>
        </div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
          <button mat-icon-button matTooltip="More...." [matMenuTriggerFor]="accountMenu"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #accountMenu="matMenu">
            <button mat-menu-item *ngIf="canEditAccount()" id="exportAccounts" (click)="exportAccounts()"><mat-icon>file_download</mat-icon> Export to Excel</button>
            <button mat-menu-item *ngIf="canConfigAccount()" id="configAccount" (click)="configAccount()"><mat-icon>settings</mat-icon> Account Configuration</button>
            <button mat-menu-item *ngIf="canManageUserAccess()" id="manageUserAccess" (click)="manageUserAccess()"><mat-icon>group_add</mat-icon> Manage User Access</button>
            <button mat-menu-item id="manageOpenAI" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator, roles.ProfessionalServices]" (click)="manageOpenAI()">
              <mat-icon style="font-size:21px; transform: translate(2px, -2px)">
                <div class="far fa-stars"></div>
              </mat-icon> Manage OpenAI Settings</button>
            <button mat-menu-item *ngIf="canMoveCase()" id="moveCaseToAccount" (click)="moveCase()"><mat-icon>drive_file_move</mat-icon> Move Case to this Account</button>
          </mat-menu>
        </div>
      </mat-toolbar>
      <!--Account Detail Content-->
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined" *ngIf="selectedAccount">
          <mat-card-content>
            <form [formGroup]="accountForm">
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 49%">
                  <div>
                    <div>
                      <mat-label class="title">Account Guid</mat-label>
                    </div>
                    <div>{{selectedAccount.accountId}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Admin Cases</mat-label>
                    </div>
                    <a [attr.id]="'goToAdminCases.'+selectedAccount.accountId" [routerLink]="['/admin/cases']" [queryParams]="{accountId:selectedAccount.accountId}">{{selectedAccount.cases.length}}</a>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Admin Users</mat-label>
                    </div>
                    <a [attr.id]="'goToAdminUsers.'+selectedAccount.accountId" [routerLink]="['/admin/users']" [queryParams]="{accountId:selectedAccount.accountId}">{{selectedAccount.users.length}}</a>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Manage Cases</mat-label>
                    </div>
                    <a [attr.id]="'goToManageCases.'+selectedAccount.accountId" [routerLink]="['/account/manage-case']" [queryParams]="{accountId:selectedAccount.accountId}" [class.disabled]="!userConfigsService.inRoles(roles.AccountFeatureSet, roles.Administrator)">{{selectedAccount.cases.length}}</a>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Manage Users</mat-label>
                    </div>
                    <a [attr.id]="'goToManageUsers.'+selectedAccount.accountId" [routerLink]="['/account/manage-user']" [queryParams]="{accountId:selectedAccount.accountId}" [class.disabled]="!userConfigsService.inRoles(roles.AccountFeatureSet, roles.Administrator)">{{nonEmployeeCount(selectedAccount.users)}}</a>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Manage Billing</mat-label>
                    </div>
                    <a [attr.id]="'goToManageBilling.'+selectedAccount.accountId" [routerLink]="['/account/manage-billing']" [queryParams]="{accountId:selectedAccount.accountId}" [class.disabled]="!userConfigsService.inRoles(roles.AccountFeatureSet, roles.Accounting, roles.Administrator)">Link</a>
                  </div>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 40%">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Account Name</mat-label>
                    <input matInput placeholder="Account Name" formControlName="accountName">
                    <mat-error *ngIf="accountForm.controls['accountName'].invalid && (accountForm.controls['accountName'].touched || accountForm.controls['accountName'].dirty)">
                      <p *ngIf="accountForm.controls['accountName'].errors.required">Name is <strong>required</strong></p>
                      <p *ngIf="accountForm.controls['accountName'].errors.maxlength">Name can not exceed <strong>256</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 7%">
                  <mat-checkbox class="full-width" matInput style="font-size: 10px; margin-bottom: 20px" formControlName="isHibernated" (change)="updateAccountName($event.checked)">Hibernated</mat-checkbox>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 50%">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Type</mat-label>
                    <input matInput placeholder="Type" formControlName="type">
                    <mat-error *ngIf="accountForm.controls['type'].invalid && (accountForm.controls['type'].touched || accountForm.controls['type'].dirty)">
                      <p *ngIf="accountForm.controls['type'].errors.maxlength">Type can not exceed <strong>256</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>CRM URL</mat-label>
                    <input matInput placeholder="CRM URL" formControlName="crmUrl">
                    <mat-error *ngIf="accountForm.controls['crmUrl'].invalid && (accountForm.controls['crmUrl'].touched || accountForm.controls['crmUrl'].dirty)">
                      <p *ngIf="accountForm.controls['crmUrl'].errors.maxlength">URL can not exceed <strong>256</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Message</mat-label>
                    <textarea matInput cdkTextareaAutosize placeholder="Message" rows="4" formControlName="message"></textarea>
                    <mat-error *ngIf="accountForm.controls['message'].invalid && (accountForm.controls['message'].touched || accountForm.controls['message'].dirty)">
                      <p *ngIf="accountForm.controls['message'].errors.maxlength">Message can not exceed <strong>256</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Comments</mat-label>
                    <textarea matInput cdkTextareaAutosize placeholder="Comments" rows="4" formControlName="accountComments"></textarea>
                    <mat-error *ngIf="accountForm.controls['accountComments'].invalid && (accountForm.controls['accountComments'].touched || accountForm.controls['accountComments'].dirty)">
                      <p *ngIf="accountForm.controls['accountComments'].errors.maxlength">Comments can not exceed <strong>1024</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </mat-card-content>
          <mat-card-actions *ngIf="canEditAccount()">
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
                <button mat-button id="deleteAccount" color="primary" type="button" (click)="delete()">Delete</button>
              </div>
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
                <button mat-button id="submitAccountForm" color="primary" type="submit" [disabled]="accountForm.pristine" (click)="updateAccount()">Update</button>
                <button mat-button id="cancelAccountForm" color="primary" type="reset" [disabled]="accountForm.pristine" (click)="cancel()">Cancel</button>
              </div>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div></div>
  </div>
  <div></div>
</div>